'use client';

import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useState } from 'react';
import { useFirestore } from 'reactfire';
import { flatten, uniq } from 'lodash';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { ChevronLeft, ChevronRight, Menu, X } from 'lucide-react';
import { nonUserFacingTags } from '@/config/templates';
import { Button, buttonVariants } from '@/shadcn/components/Button';
import { NavigationMenu, NavigationMenuItem, NavigationMenuList } from '@/shadcn/components/NavigationMenu';
import generalSettings from '@/config/general';
import useSharedWidgets from '@/common/hooks/useSharedWidgets';
import { ChartsDesktop, ChartsMobile } from './Charts'; // import { CalculatorsDesktop, CalculatorsMobile } from './Calculators';

import { TemplatesDesktop, TemplatesMobile } from './Templates';

var Logo = function Logo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "m65.364 15.406c1.4179-3.216 4.0809-4.825 7.9881-4.825v6.0691c-2.1437-0.1382-4.0118 0.3715-5.6016 1.5303-1.5907 1.1587-2.3865 3.0691-2.3865 5.7312v13.071h-5.6016v-25.935h5.6016v4.3584z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m96.849 11.049h5.6014v25.935h-5.6014v-3.7344c-2.1091 2.9395-5.1351 4.4093-9.0778 4.4093-3.5616 0-6.6048-1.3229-9.1286-3.9677-2.5238-2.6458-3.7862-5.8704-3.7862-9.6739 0-3.8381 1.2624-7.0714 3.7862-9.6989 2.5248-2.6285 5.568-3.9427 9.1286-3.9427 3.9418 0 6.9677 1.4524 9.0778 4.3574v-3.6845zm-14.057 18.907c1.5562 1.5735 3.5107 2.3597 5.8618 2.3597 2.351 0 4.3046-0.7872 5.8608-2.3597 1.5561-1.5734 2.3337-3.5529 2.3337-5.9395 0-2.3856-0.7785-4.3661-2.3337-5.9386-1.5562-1.5734-3.5098-2.3596-5.8608-2.3596-2.3511 0-4.3056 0.7862-5.8618 2.3596-1.5561 1.5735-2.3337 3.553-2.3337 5.9386 0 2.3866 0.7785 4.3661 2.3337 5.9395z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m123.66 10.375c3.562 0 6.605 1.3229 9.129 3.9677 2.525 2.6458 3.786 5.8694 3.786 9.673 0 3.839-1.262 7.0713-3.786 9.6998s-5.567 3.9427-9.129 3.9427c-3.942 0-6.967-1.4525-9.077-4.3574v14.056h-5.602v-36.309h5.602v3.7354c2.109-2.9396 5.135-4.4093 9.077-4.4093v9e-4zm-6.743 19.581c1.556 1.5734 3.51 2.3596 5.861 2.3596 2.352 0 4.306-0.7872 5.862-2.3596 1.556-1.5735 2.334-3.553 2.334-5.9396 0-2.3856-0.778-4.366-2.334-5.9385-1.556-1.5735-3.51-2.3597-5.862-2.3597-2.351 0-4.305 0.7862-5.861 2.3597-1.556 1.5734-2.333 3.5529-2.333 5.9385 0 2.3866 0.777 4.3661 2.333 5.9396z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m155.3 10.375c2.974 0 5.378 0.9514 7.21 2.8531 1.832 1.9018 2.749 4.512 2.749 7.8317v15.924h-5.603v-15.353c0-1.9363-0.518-3.4233-1.556-4.4611-1.037-1.0378-2.454-1.5562-4.253-1.5562-1.971 0-3.561 0.6144-4.772 1.8423-1.209 1.2278-1.815 3.1036-1.815 5.6275v13.901h-5.602v-36.309h5.602v13.693c1.694-2.663 4.375-3.9936 8.04-3.9936z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m171.28 36.984v-25.935h5.602v25.935h-5.602z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m176.6 6.7699c-0.709 0.70944-1.548 1.0627-2.515 1.0627-0.968 0-1.807-0.35425-2.516-1.0627-0.708-0.70848-1.063-1.5475-1.063-2.5162 0-0.96768 0.345-1.8067 1.036-2.5152 0.692-0.70944 1.539-1.0637 2.543-1.0637 1.002 0 1.849 0.35424 2.542 1.0637 0.691 0.70848 1.036 1.5475 1.036 2.5152 0 0.96864-0.354 1.8077-1.063 2.5162z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m193.44 16.444h-6.432v12.448c0 1.0723 0.243 1.8413 0.727 2.3088 0.483 0.4665 1.201 0.7258 2.152 0.7776s2.135 0.0432 3.553-0.0269v5.0314c-4.288 0.5193-7.365 0.1468-9.233-1.1146-1.868-1.2624-2.801-3.5875-2.801-6.9763v-23.446l5.602-1.6598v7.2614h6.432v5.3962z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m216.27 11.049h5.601v25.935h-5.601v-3.3197c-1.695 2.663-4.375 3.9946-8.04 3.9946-2.974 0-5.377-0.9514-7.21-2.8531-1.832-1.9018-2.749-4.513-2.749-7.8327v-15.924h5.601v15.354c0 1.9363 0.52 3.4233 1.557 4.4601 1.037 1.0378 2.455 1.5562 4.253 1.5562 1.971 0 3.562-0.6144 4.772-1.8413 1.21-1.2278 1.816-3.1037 1.816-5.6285v-13.901z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m243.08 10.375c3.561 0 6.604 1.3229 9.128 3.9677 2.525 2.6458 3.786 5.8694 3.786 9.673 0 3.839-1.262 7.0713-3.786 9.6998s-5.567 3.9427-9.128 3.9427c-3.943 0-6.968-1.4525-9.078-4.3574v14.056h-5.602v-36.309h5.602v3.7354c2.109-2.9396 5.135-4.4093 9.078-4.4093v9e-4zm-6.744 19.581c1.557 1.5734 3.51 2.3596 5.861 2.3596 2.352 0 4.306-0.7872 5.862-2.3596 1.556-1.5735 2.334-3.553 2.334-5.9396 0-2.3856-0.778-4.366-2.334-5.9385-1.556-1.5735-3.51-2.3597-5.862-2.3597-2.351 0-4.304 0.7862-5.861 2.3597-1.556 1.5734-2.333 3.5529-2.333 5.9385 0 2.3866 0.777 4.3661 2.333 5.9396z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m54.679 18.207v2.4902c0 4.9795-1.6426 9.0509-4.9277 12.215-3.2851 3.1641-7.5735 4.7462-12.864 4.7462-5.6016 0-10.227-1.8163-13.875-5.4461-1.945-1.9363-3.3715-4.1088-4.2797-6.5165h6.5357c0.5299 0.8851 1.1779 1.7088 1.945 2.4711 2.4729 2.4547 5.7139 3.6825 9.7257 3.6825 3.216 0 5.8349-0.7516 7.8576-2.256 2.0227-1.5043 3.3101-3.5184 3.865-6.0432h-12.138v-5.3424h18.155l1e-3 -9e-4zm-27.767-15.751c2.8301-1.6368 6.0509-2.4557 9.6643-2.4557 3.3888 0 6.4839 0.77857 9.2852 2.3338 2.8012 1.5562 4.9795 3.648 6.5356 6.2765l-5.135 2.9568c-0.9686-1.7289-2.4038-3.1209-4.3056-4.176-1.9018-1.0541-4.0291-1.5821-6.3802-1.5821-3.8035 0-6.9331 1.2451-9.3888 3.7354-0.094 0.09504-0.1852 0.19104-0.2755 0.288v-7.3766z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.9606 22.5706H17.9414V0H23.9606V22.5706Z",
      clipRule: "evenodd",
      fill: "#00C093",
      fillRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      d: "m14.989 33.153h-6.0192v-22.571h6.0192v22.571z",
      clipRule: "evenodd",
      fill: "#00C093",
      fillRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.0192 24.8121H0V2.24158H6.0192V24.8121Z",
      clipRule: "evenodd",
      fill: "#00C093",
      fillRule: "evenodd"
    })]
  }));
};

Logo.defaultProps = {
  viewBox: "0 0 256 48",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Navigation = _ref => {
  let {
    className
  } = _ref;
  const {
    route
  } = useRouter();
  const {
    0: open,
    1: setOpen
  } = useState(false);
  const {
    0: submenu,
    1: setSubmenu
  } = useState(null);
  const isLogin = route.search('/login') === 0;
  const isSignup = route.search('/signup') === 0;
  const firestore = useFirestore();
  const {
    data: widgets
  } = useSharedWidgets(firestore);
  const uniqueTags = uniq(flatten(widgets.map(_ref2 => {
    let {
      tags
    } = _ref2;
    return tags || [];
  })));
  const filters = uniqueTags.filter(tag => !nonUserFacingTags.includes(tag)).map(name => ({
    name,
    counter: widgets.reduce((acc, _ref3) => {
      let {
        tags
      } = _ref3;
      return acc += (tags || []).includes(name) ? 1 : 0;
    }, 0)
  }));
  return /*#__PURE__*/_jsx("div", {
    className: clsx('bg-white', className),
    children: /*#__PURE__*/_jsx("header", {
      className: "px-6 xl:px-14 py-0.5",
      children: /*#__PURE__*/_jsxs(NavigationMenu, {
        className: clsx(styles.navigationMenu, 'min-w-full'),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex w-full items-center justify-between gap-12 py-4",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [(!open || !submenu) && /*#__PURE__*/_jsx("a", {
              href: "/",
              className: clsx(styles.logo, 'flex items-center'),
              title: `${generalSettings.productName} home`,
              children: /*#__PURE__*/_jsx(Logo, {})
            }), open && submenu && /*#__PURE__*/_jsxs(Button, {
              variant: "outline",
              onClick: () => setSubmenu(null),
              children: ["Back", /*#__PURE__*/_jsx(ChevronLeft, {
                className: "ml-2 size-4"
              })]
            })]
          }), /*#__PURE__*/_jsxs(NavigationMenuList, {
            className: "hidden lg:flex",
            children: [/*#__PURE__*/_jsx(ChartsDesktop, {}), /*#__PURE__*/_jsx(TemplatesDesktop, {
              filters: filters
            }), /*#__PURE__*/_jsx(NavigationMenuItem, {
              children: /*#__PURE__*/_jsx(Link, {
                href: '/pricing',
                className: buttonVariants({
                  variant: 'ghost'
                }),
                children: "Pricing"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "hidden items-center gap-4 lg:flex",
            children: [!isLogin && /*#__PURE__*/_jsx(Link, {
              href: '/login',
              className: buttonVariants({
                variant: 'ghost'
              }),
              children: "Log in"
            }), !isSignup && /*#__PURE__*/_jsxs(Link, {
              href: '/signup',
              className: buttonVariants({
                variant: 'outline'
              }),
              children: ["Start now", /*#__PURE__*/_jsx(ChevronRight, {
                className: "ml-2 size-4"
              })]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "flex items-center gap-4 lg:hidden",
            children: /*#__PURE__*/_jsxs(Button, {
              variant: "outline",
              size: "icon",
              "aria-label": "Main Menu",
              onClick: () => {
                if (open) {
                  setOpen(false);
                  setSubmenu(null);
                } else {
                  setOpen(true);
                }
              },
              children: [!open && /*#__PURE__*/_jsx(Menu, {
                className: "size-4"
              }), open && /*#__PURE__*/_jsx(X, {
                className: "size-4"
              })]
            })
          })]
        }), open && /*#__PURE__*/_jsxs("div", {
          className: "fixed inset-0 top-[48px] flex w-full flex-col overflow-auto border-t border-border bg-white lg:hidden",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "flex w-full items-center border-b border-border px-8 py-7 text-left",
              onClick: () => setSubmenu('charts'),
              children: [/*#__PURE__*/_jsx("span", {
                className: "flex-1",
                children: "Charts"
              }), /*#__PURE__*/_jsx("span", {
                className: "shrink-0",
                children: /*#__PURE__*/_jsx(ChevronRight, {
                  className: "size-4"
                })
              })]
            }), /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "flex w-full items-center border-b border-border px-8 py-7 text-left",
              onClick: () => setSubmenu('calculators'),
              children: [/*#__PURE__*/_jsx("span", {
                className: "flex-1",
                children: "Calculators"
              }), /*#__PURE__*/_jsx("span", {
                className: "shrink-0",
                children: /*#__PURE__*/_jsx(ChevronRight, {
                  className: "size-4"
                })
              })]
            }), /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "flex w-full items-center border-b border-border px-8 py-7 text-left",
              onClick: () => setSubmenu('templates'),
              children: [/*#__PURE__*/_jsx("span", {
                className: "flex-1",
                children: "Templates"
              }), /*#__PURE__*/_jsx("span", {
                className: "shrink-0",
                children: /*#__PURE__*/_jsx(ChevronRight, {
                  className: "size-4"
                })
              })]
            }), /*#__PURE__*/_jsx(Link, {
              href: '/pricing',
              type: "button",
              className: "flex w-full items-center border-b border-border px-8 py-7 text-left",
              children: /*#__PURE__*/_jsx("span", {
                className: "flex-1",
                children: "Pricing"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "mx-8 mt-auto flex flex-col gap-4 py-12",
            children: [!isLogin && /*#__PURE__*/_jsxs(Link, {
              href: '/login',
              className: clsx(buttonVariants({
                variant: 'outline'
              }), 'relative'),
              children: ["Log in", /*#__PURE__*/_jsx(ChevronRight, {
                className: "absolute right-2 size-4"
              })]
            }), !isSignup && /*#__PURE__*/_jsxs(Link, {
              href: '/signup',
              className: clsx(buttonVariants({
                variant: 'default'
              }), 'relative'),
              children: ["Start now", /*#__PURE__*/_jsx(ChevronRight, {
                className: "absolute right-2 size-4"
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(ChartsMobile, {
          open: open,
          submenu: submenu
        }), /*#__PURE__*/_jsx(TemplatesMobile, {
          filters: filters,
          open: open,
          submenu: submenu
        })]
      })
    })
  });
};

export default Navigation;